module.exports = __webpack_public_path__ + "static/media/3ea3623d.jpg";